import type * as React from 'react';

function SvgEyes(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M12 8.5073C10.0742 8.5073 8.5068 10.0742 8.5068 12C8.5068 13.9258 10.0742 15.4927 12 15.4927C13.9258 15.4927 15.4932 13.9258 15.4932 12C15.4932 10.0742 13.9258 8.5073 12 8.5073ZM12 13.9927C10.9014 13.9927 10.0068 13.0987 10.0068 12C10.0068 10.9013 10.9013 10.0073 12 10.0073C13.0987 10.0073 13.9932 10.9013 13.9932 12C13.9932 13.0987 13.0987 13.9927 12 13.9927Z"
        fill="currentColor"
      />
      <path
        d="M21.9482 11.6836C21.9267 11.6167 19.6328 5 12 5C4.3672 5 2.0732 11.6167 2.0518 11.6836C2 11.8384 1.9864 12.0034 2.0137 12.1646C2.0254 12.233 3.2539 19 12 19C19.6328 19 21.9268 12.3833 21.9482 12.3164C22.0175 12.1108 22.0175 11.8892 21.9482 11.6836ZM12 17C5.7881 17 4.3213 13.1025 4.042 12.0752C4.4854 11.0186 6.5303 7 12 7C17.3506 7 19.4238 10.8457 19.9258 11.9995C19.4219 13.1582 17.3477 17 12 17Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgEyes;
